<section>
  <div>
    <div class="row align-items-center mx-0 p-1">
      <div class="col">
        <h6 class="m-0">
          {{ isFormView ? 'Registrar detalle de nota' : 'Detalle de nota' }}
        </h6>
      </div>
      <div class="col text-end">
        <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disableDetail" [width]="'7rem'"
          (onClick)="openRegister()"></app-custom-button>
      </div>
    </div>
    <div class="row mx-0">
      <ng-container *ngIf="!disableDetail">
        <div class="pb-2" [hidden]="!isFormView">
          <app-register-provider-note-detail [providerNoteModel]="providerNoteModel"
            [permissionUpdatable]="permissionUpdatable" [providerNoteDetailModel]="providerNoteDetailModel"
            (updateListDetail)="getUpdateListDetail()" (providerNoteContract)="getProviderNote($event)"
            (isFormView)="getFormView($event)"></app-register-provider-note-detail>
        </div>
      </ng-container>
    </div>
    <div class="">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="disableDetail ? [] : tableActions"
          [showCheckbox]="!disableDetail" [checkBoxAction]="checkboxActions"
          [clearSelectionTrigger]="clearSelectionTrigger" (onAction)="onAction($event)"
          (onPageChange)="onPageChange($event)">
        </app-custom-table>
      </div>
    </div>
  </div>
</section>